module.exports = __webpack_public_path__ + "img/ORDER-CNN.52e2e61f.png";